import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SohoButtonModule, SohoComponentsModule, SohoLocaleModule } from 'ids-enterprise-ng';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Authentication } from './services/authentication';
import { SohoLocaleInitializerModule } from './locale/soho-locale-initializer.module';
import { HeaderComponent } from './header/header.component';
import { CookieService } from 'ngx-cookie-service';
import { AppMastheadComponent } from './app-masthead';
import { AppHeaderComponent1 } from './app-header';
import { LandingComponent } from './landing/landing.component';
import { AppService } from './app.service';
import { UploadComponent } from './upload/upload.component';
import { UploadRequestsComponent } from './upload-requests/upload-requests.component';
import { TerritoryBudgetsComponent } from './territory-budgets/territory-budgets.component';
import { Capacitymodel360Component } from './capacitymodel360/capacitymodel360.component';
import { DetailedUploadComponent } from './detailed-upload/detailed-upload.component';
import { FinalQuotaListComponent } from './final-quota-list/final-quota-list.component';
import { QuotaInputComponent } from './quota-input/quota-input.component';
import { QuotaInputGicComponent } from './quota-input-gic/quota-input-gic.component';
import { EditDetailedUploadComponent } from './edit-detailed-upload/edit-detailed-upload.component';
import { EditFinalQuotaComponent } from './edit-final-quota/edit-final-quota.component';
import { EditQuotaInputComponent } from './edit-quota-input/edit-quota-input.component';
import { AuthHelper } from './services/authHelper';
import { UserData } from './shared/models/user.model';
import { DetailedQuotaData, QuotaInputData, TerritoryBudgetData, UploadRequestModel, UploadResponseModel,StaffSecurityRoleData, RolePlanTypeMappingData, RolePayCurveMappingData, } from './models/cm-model';
import { CapacityModelService } from './services/CapacityModel-Service';
import { ValidateDataService } from './services/validate-data.service';
import { HttpInterceptorModule } from './http-interceptor.module';
import { ApplicationMenuComponent } from './application-menu/application-menu.component';
import { DownloadTemplateComponent } from './download-template/download-template-component';
import { FileDownloadService } from './services/FileDownload-Service';
import { QuotaInputManualGicComponent } from './quota-input-manual-gic/quota-input-manual-gic.component';
import { UploadManualComponent } from './upload-manual/upload-manual.component';
import { UploadManualRequestsComponent } from './upload-manual-requests/upload-manual-requests.component';
import { DownloadManualTemplateComponent } from './download-manual-templates/download-manual-template-component';
import { AccessControllerComponent } from './access-controller/access-controller.component';
import {EditAccessComponent} from './edit-access/edit-access.component';
import { EditAccessControllerComponent } from './edit-access-controller/edit-access-controller.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { ArchivefileListComponent } from './archivefile-list/archivefile-list.component';
import { RolePlanTypeMappingComponent } from './role-plan-type-mapping/role-plan-type-mapping.component';
import { AddRolePlanTypeMappingComponent } from './add-role-plan-type-mapping/add-role-plan-type-mapping.component';
import { EditRolePlanTypeMappingComponent } from './edit-role-plan-type-mapping/edit-role-plan-type-mapping.component';
import { RolePayCurveMappingComponent } from './role-pay-curve-mapping/role-pay-curve-mapping.component';
import { AddRolePayCurveMappingComponent } from './add-role-pay-curve-mapping/add-role-pay-curve-mapping.component';
import { EditRolePayCurveMappingComponent } from './edit-role-pay-curve-mapping/edit-role-pay-curve-mapping.component';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent, 
    LandingComponent,
    AppMastheadComponent,
    AppHeaderComponent1,
    Capacitymodel360Component,
    DetailedUploadComponent,
    ApplicationMenuComponent,
    TerritoryBudgetsComponent,
    UploadComponent,
    UploadRequestsComponent,
    FinalQuotaListComponent,
    QuotaInputComponent,
    QuotaInputGicComponent,
    EditDetailedUploadComponent,
    EditFinalQuotaComponent,
    EditQuotaInputComponent,
    DownloadTemplateComponent,
    QuotaInputManualGicComponent,
    UploadManualComponent,
    UploadManualRequestsComponent,
    DownloadManualTemplateComponent,
    AccessControllerComponent,
    EditAccessComponent,
    EditAccessControllerComponent,
    AccessDeniedComponent,
    ArchivefileListComponent,
    RolePlanTypeMappingComponent,
    AddRolePlanTypeMappingComponent,
    EditRolePlanTypeMappingComponent,
    RolePayCurveMappingComponent,
    AddRolePayCurveMappingComponent,
    EditRolePayCurveMappingComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SohoLocaleModule,
    SohoButtonModule,
    SohoLocaleInitializerModule,
    SohoComponentsModule,
    HttpInterceptorModule
  ],
  providers: [
    Authentication,
    CookieService,
    AppService, 
    {
      provide: LOCALE_ID,
      useValue: 'en-US'      
    },
    AuthHelper,
    UserData,
    TerritoryBudgetData,
    CapacityModelService,
    FileDownloadService,
    ValidateDataService,
    UploadRequestModel,
    UploadResponseModel,
    QuotaInputData,
    DetailedQuotaData,
    StaffSecurityRoleData,
    RolePlanTypeMappingData,
    RolePayCurveMappingData
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
